// extracted by mini-css-extract-plugin
export default {"halal":"Halal_halal__gImi3","ar":"Halal_ar__YP5kL","en":"Halal_en__wOywe","with-badge":"Halal_with-badge__H32vb"};